
export default {
  props: {
    price: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['small', 'medium', 'large'].includes(value),
    },
  },
}
